module.exports = __webpack_public_path__ + "static/img/tutorial-product-price-1.ae40013.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-product-price-1.jpg
// module id = eXbr
// module chunks = 3